import { NgModule } from '@angular/core';
import { MeasurementService } from './measurement.service';

@NgModule({
  providers: [MeasurementService],
})
export class MeasurementModule {}
